const loadCompanyInfo = 'LOADCOMPANYINFO'
const loadProductCategory = 'LOADPRODUCTCATEGORY'

export {
  loadCompanyInfo,
  loadProductCategory
}
